import { useAtomValue } from "jotai";
import type { FunctionComponent } from "react";
import { graphql, readInlineData } from "react-relay";

import { EntityLink } from "scmp-app/components/entity-link";
import { getResponsiveProps } from "scmp-app/components/header/features/helpers";
import type { HeaderFeatureCommonProps } from "scmp-app/components/header/features/types";
import { currentArticleAtom } from "scmp-app/lib/current-item";
import type { sectionHeaderFeaturesArticle$key } from "scmp-app/queries/__generated__/sectionHeaderFeaturesArticle.graphql";

import { Container } from "./styles";

export type HeaderFeaturesSectionProps = HeaderFeatureCommonProps & {
  isMagazineStyle?: boolean;
  size?: sectionNameSize;
};

export type sectionNameSize = "large" | "small";

export const HeaderFeaturesSection: FunctionComponent<HeaderFeaturesSectionProps> = ({
  isMagazineStyle = false,
  size = "small",
  ...props
}) => {
  const currentArticle = useAtomValue(currentArticleAtom);
  if (!currentArticle) return null;

  const data = readInlineData<sectionHeaderFeaturesArticle$key>(
    graphql`
      fragment sectionHeaderFeaturesArticle on Article @inline {
        sections {
          value {
            name
            ...entityLink
          }
        }
      }
    `,
    currentArticle,
  );
  if (!data?.sections?.[0]?.value) return null;

  const firstSection = data.sections[0].value;
  // Take last section
  const section = firstSection.at(-1);

  if (!section) return null;

  const sectionName = section.name ?? null;

  return (
    <Container $isMagazineStyle={isMagazineStyle} $size={size} {...getResponsiveProps(props)}>
      <EntityLink reference={section}>{sectionName}</EntityLink>
    </Container>
  );
};

HeaderFeaturesSection.displayName = "HeaderFeaturesSection";
